import('./nav_item.scss')

export default function NavItem(opts={}){
    
    BaseConstructor.call(this)
    let {container, navItem={},position, icon_options={}} = opts
    let elements = {}
    let context = this

    this.getElement = _ =>{
        return elements.container
    }

    this.generate = () =>{
        
    }

    this.setActive = boolean =>{
        $(elements.container).toggleClass('active', boolean)
    }

    init()

    function init(){
        elements.container = context.createElement('div', `leaflet-map-nav-item ${position || 'topright' } ${icon_options.show_title ? 'show-title' : ''} ${navItem.active? 'active' : ''}`, `<div class='title'>${navItem.title}</div><div class='icon'>${navItem.icon}</div>`)

        $(elements.container).on('click', _ =>{
            context.trigger('nav-item-click', navItem)
        })
    }
    
}

NavItem.prototype = Object.create(BaseConstructor.prototype)